module.exports = __webpack_public_path__ + "img/poker-c07.05ee7922.svg";